import * as z from 'zod';

// Types
import { TextZod } from '@/components/molecules/Text/TextType';
import { BubbleStyleZod } from '@/types/BubbleStyleType';

const TextBubbleZod = z.object({
  id: z.number(),
  content: TextZod,
  textAlign: z.enum(['left', 'center', 'right']).nullable(),
  bubbleStyle: BubbleStyleZod,
});

export { TextBubbleZod };
export type TextBubbleType = z.infer<typeof TextBubbleZod>;
